module.exports = __webpack_public_path__ + "img/img.zcool.276081da.jpg";